import { EnrollmentInvestmentExperienceCategory } from '@egw/api'

export interface InvestmentOptionExperience {
  value: EnrollmentInvestmentExperienceCategory
  label: string
}

/**
 * Sorts investment experience options in a logical order for display
 * Priority order: None, Very Little, Some, Moderate, A Lot
 */
export const sortInvestmentOptionExperiences = (
  options: InvestmentOptionExperience[],
): InvestmentOptionExperience[] => {
  const priorityOrder = [
    EnrollmentInvestmentExperienceCategory.NONE,
    EnrollmentInvestmentExperienceCategory.VERY_LITTLE,
    EnrollmentInvestmentExperienceCategory.SOME,
    EnrollmentInvestmentExperienceCategory.MODERATE,
    EnrollmentInvestmentExperienceCategory.A_LOT,
  ]

  return [...options].sort((a, b) => {
    const aIndex = priorityOrder.indexOf(a.value)
    const bIndex = priorityOrder.indexOf(b.value)

    // If both values are in the priority order, sort by their position
    if (aIndex !== -1 && bIndex !== -1) {
      return aIndex - bIndex
    }

    // If only one is in the priority order, prioritize it
    if (aIndex !== -1) return -1
    if (bIndex !== -1) return 1

    // If neither is in the priority order, maintain original order
    return 0
  })
}
